module.exports = __webpack_public_path__ + "static/media/lora_co2_modbus_en.b2e3c106.md";